import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import AddCameraButton from './components/AddCameraButton';
import './RightBar.css';
import {
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  IconButton,
  Typography,
  Snackbar,
  Alert,
  Drawer,
  MenuItem,
  Menu
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { deleteCamera, getEvidenceCameras } from '../../../../api/FM/videoPageApis';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { CloseOutlined } from '@mui/icons-material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
// import Switch from '@mui/material/Switch';
import { MdCameraAlt } from 'react-icons/md';
import EvidenceList from '../evidencePage/evidenceList';
// import DatePickerStore from '../Calendar';

const CameraCard = ({ camera, onSelect }) => {
  const dispatch = useDispatch();
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const videoPlaying = useSelector((state) => state.cameraReducer.videoPlaying);
  const selectedCamera = useSelector((state) => state.cameraReducer.cameraData);
  const isSelected = selectedCamera && selectedCamera._id === camera._id;
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleMenuClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleDeleteCamera = async () => {
    try {
      setIsDeleting(true);
      await deleteCamera(camera._id);
      dispatch({ type: 'CAMERA_ADDED' }); // Reuse this action to trigger refetch
      dispatch({ type: 'VIDEO_PLAYING', videoPlaying: false }); // Reset video playing state
      setSnackbar({
        open: true,
        message: 'Camera deleted successfully',
        severity: 'success'
      });
    } catch (error) {
      setSnackbar({
        open: true,
        message: error?.message || 'Failed to delete camera',
        severity: 'error'
      });
    } finally {
      setIsDeleting(false);
      setIsDeleteModalOpen(false);
    }
  };

  const handleDeleteClick = (e) => {
    e.stopPropagation();
    if (videoPlaying) {
      dispatch({ type: 'VIDEO_PLAYING', videoPlaying: false }); // Reset video playing state before opening dialog
    }
    setIsDeleteModalOpen(true);
  };

  // const handleToggleCamera = async (cameraId) => {
  //   try {
  //     // Toggle active state
  //     await updateCameraStatus(cameraId, !camera.active);
  //     dispatch({ type: 'CAMERA_ADDED' }); // Refresh camera list
  //   } catch (error) {
  //     console.error('Error toggling camera:', error);
  //   }
  // };

  console.log('abc', camera.thumbnail);
  useEffect(() => {
    if (camera.thumbnail) {
      console.log('Thumbnail URL:', camera.thumbnail);
      console.log('Is valid URL:', isValidUrl(camera.thumbnail)); // Implement this helper
      console.log('Is base64:', camera.thumbnail.startsWith('data:image'));
    }
  }, [camera.thumbnail]);

  // Helper function
  function isValidUrl(string) {
    try {
      new URL(string);
      return true;
    } catch (_) {
      return false;
    }
  }

  return (
    <div
      className={`flex bg-white rounded-lg shadow-lg text-xs p-4 relative hover:shadow-xl transition-all ${
        isSelected ? 'border-2 border-blue-500 bg-blue-50' : ''
      } ${!camera.active ? 'cursor-not-allowed opacity-75' : 'cursor-pointer'}`}
      onClick={(e) => {
        if (!camera.active) {
          e.preventDefault();
          return;
        }
        console.log('Camera clicked:', camera);
        dispatch({ type: 'CAMERA_DATA', cameraData: camera });
        if (onSelect) onSelect(camera);
      }}
    >
      {/* Left Side: Camera Thumbnail */}
      {/* <div className="flex w-1/3 items-center justify-center bg-gray-200 rounded-lg overflow-hidden">
        {camera?.thumbnail ? (
          <img src={camera?.thumbnail} alt="Camera Thumbnail" className="w-full h-full object-cover" />
        ) : (
          <MdCameraAlt className="text-gray-500 text-4xl" />
        )}
      </div> */}

      <div className="relative flex w-1/3 items-center justify-center bg-gray-200 rounded-lg overflow-hidden h-24">
        {camera?.thumbnail ? (
          <>
            <iframe
              src="https://drive.google.com/file/d/1HApZV74Juy9lWwsiv9jTQwSyxUWrX_RR/preview"
              width="100%"
              height="100%"
              className="object-cover pointer-events-none"
              allow="autoplay"
            />
            {/* Overlay div to prevent zoom and pop-out */}
            <div className="absolute inset-0"></div>
          </>
        ) : (
          <div className="flex items-center justify-center w-full h-full bg-gray-200">
            <MdCameraAlt className="text-gray-500 text-4xl" />
          </div>
        )}
      </div>

      {/* Right Side: Camera Info */}
      <div className="flex flex-col flex-grow px-4">
        <div className="flex items-center gap-2 mb-2">
          <h2 className="text-2xl font-semibold">{camera.device_name}</h2>
          {/* <Switch checked={camera.active} onChange={() => handleToggleCamera(camera._id)} color="success" /> */}
        </div>

        <div className="flex flex-wrap gap-2 mb-2">
          {Object.keys(camera.zones || {})
            .slice(0, 2)
            .map((zoneName) => (
              <span key={zoneName} className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-xs">
                {zoneName}
              </span>
            ))}
          {Object.keys(camera.zones || {}).length > 2 && <span className="px-3 py-1 rounded-full text-xs">...</span>}
        </div>
      </div>

      {/* Actions Menu */}
      <div className="absolute top-2 right-2">
        <IconButton size="small" onClick={handleMenuClick}>
          <MoreVertIcon />
        </IconButton>
      </div>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem onClick={() => console.log('View details')}>Edit</MenuItem>
        <MenuItem onClick={handleDeleteClick}>Delete</MenuItem>
      </Menu>

      {/* Delete Confirmation Dialog */}
      <Dialog open={isDeleteModalOpen} onClose={() => !isDeleting && setIsDeleteModalOpen(false)}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <DialogContentText>Are you sure you want to delete this camera? This will also delete all associated zones.</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsDeleteModalOpen(false)} color="primary" disabled={isDeleting}>
            Cancel
          </Button>
          <Button onClick={handleDeleteCamera} color="error" disabled={isDeleting} startIcon={isDeleting && <CircularProgress size={20} />}>
            {isDeleting ? 'Deleting...' : 'Delete'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar Notification */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

const RightEvidenceBar = () => {
  const dispatch = useDispatch();
  const [cameras, setCameras] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [showEvidenceList, setShowEvidenceList] = useState(false);
  const cameraAdded = useSelector((state) => state.cameraReducer.cameraAdded);
  const [error, setError] = useState(null);
  const selectedCamera = useSelector((state) => state.cameraReducer.cameraData);
  const selectedDate = useSelector((state) => state.customization.currentDate);

  const fetchCameras = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await getEvidenceCameras();
      console.log('Fetched cameras response1:', response);
      const camerasArray = response?.cameras || [];
      console.log('Processed cameras array:', camerasArray);
      setCameras(camerasArray);
    } catch (err) {
      console.error('Error fetching cameras:', err);
      setError(err.message || 'Failed to fetch cameras');
    } finally {
      setLoading(false);
    }
  };

  console.log('abc1', cameras.thumbnail);

  useEffect(() => {
    console.log('cameraAdded state changed:', cameraAdded);
    fetchCameras();
    if (cameraAdded) {
      dispatch({ type: 'RESET_CAMERA_ADDED' });
    }
  }, [cameraAdded, dispatch]);

  useEffect(() => {
    if (selectedDate && selectedCamera) {
      setShowEvidenceList(true);
    } else {
      setShowEvidenceList(false);
    }
  }, [selectedDate, selectedCamera]);

  const handleBackToDevices = () => {
    setShowEvidenceList(false);
  };

  return (
    <>
      <div className="relative lg:mt-0-mt-[200%] ">
        <IconButton className="absolute top-2 right-2 z-50 md:hidden" onClick={() => setIsDrawerOpen(true)}>
          <ArrowForwardIcon fontSize="small" style={{ color: 'black' }} />
        </IconButton>
      </div>

      {/* Mobile Drawer */}
      <Drawer anchor="right" open={isDrawerOpen} onClose={() => setIsDrawerOpen(false)} className="md:hidden">
        <div className="w-80 p-4 bg-slate-100 border border-gray-300 h-full overflow-y-auto rounded-lg">
          <IconButton onClick={() => setIsDrawerOpen(false)}>
            <CloseOutlined fontSize="small" style={{ color: 'black' }} />
          </IconButton>
          <div className="p-4">
            {showEvidenceList ? (
              <>
                <div className="flex items-center mb-4">
                  <IconButton onClick={handleBackToDevices} size="small" className="mr-2">
                    <ArrowBackIcon fontSize="small" />
                  </IconButton>
                  <Typography variant="h5" className="font-medium">
                    Evidence
                  </Typography>
                </div>
                {selectedDate && selectedCamera?.device_name && <EvidenceList date={selectedDate} device={selectedCamera} />}
              </>
            ) : (
              <>
                <div className="flex justify-between items-center mb-4">
                  <Typography variant="h4" className="font-medium">
                    Cameras
                  </Typography>
                  <AddCameraButton />
                </div>

                <div className="space-y-4">
                  {loading ? (
                    <div className="flex justify-center items-center h-full">
                      <CircularProgress />
                    </div>
                  ) : error ? (
                    <div className="flex justify-center items-center h-full">
                      <Typography variant="body1" color="error">
                        {error}
                      </Typography>
                    </div>
                  ) : cameras.length === 0 ? (
                    <div className="flex justify-center items-center h-full">
                      <Typography variant="body1" color="textSecondary">
                        No cameras found
                      </Typography>
                    </div>
                  ) : (
                    cameras
                      .slice()
                      .sort((a, b) => (b.active === a.active ? 0 : b.active ? 1 : -1))
                      .map((camera) => <CameraCard key={camera._id} camera={camera} />)
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </Drawer>

      {/* Desktop View */}
      <div className="hidden md:block bg-slate-100 border border-gray-300 h-full w-full overflow-y-auto rounded-lg">
        <div className="p-4">
          {showEvidenceList ? (
            <>
              <div className="flex items-center mb-4">
                <IconButton onClick={handleBackToDevices} size="small" className="mr-2">
                  <ArrowBackIcon fontSize="small" />
                </IconButton>
                <Typography variant="h5" className="font-medium">
                  Evidence - {selectedCamera?.device_name}
                </Typography>
              </div>
              {selectedDate && selectedCamera?.device_name && <EvidenceList date={selectedDate} device={selectedCamera} />}
            </>
          ) : (
            <>
              <div className="flex justify-between items-center mb-4">
                <Typography variant="h5" className="font-medium">
                  Cameras
                </Typography>

                {/* <DatePickerStore
                  sx={{
                    '& .MuiInputBase-root': {
                      height: '28px',
                      fontSize: { xs: '0.6rem', sm: '0.65rem', xl: '0.8rem' },
                      width: { xs: '90px', sm: '90px', xl: '120px' },
                      padding: '4px 8px' // Adjust padding if needed
                    }
                  }}
                /> */}

                {/* <AddCameraButton /> */}
              </div>

              <div className="space-y-4">
                {loading ? (
                  <div className="flex justify-center items-center h-full">
                    <CircularProgress />
                  </div>
                ) : error ? (
                  <div className="flex justify-center items-center h-full">
                    <Typography variant="body1" color="error">
                      {error}
                    </Typography>
                  </div>
                ) : cameras.length === 0 ? (
                  <div className="flex justify-center items-center h-full">
                    <Typography variant="body1" color="textSecondary">
                      No cameras found
                    </Typography>
                  </div>
                ) : (
                  cameras
                    .slice()
                    .sort((a, b) => (b.active === a.active ? 0 : b.active ? 1 : -1))
                    .map((camera) => <CameraCard key={camera._id} camera={camera} />)
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default RightEvidenceBar;
